/* eslint-disable no-use-before-define */
import React from 'react';
import PropTypes from 'prop-types';
import { Anchor, Image, NumberFormatter } from '@mantine/core';
import { AlertCircle } from 'tabler-icons-react';
import AppStack from '../../common/AppStack';
import AppFlexbox from '../../common/AppFlexbox';
import AppText from '../../common/AppText';
import { isUrlString } from '../../../helpers/format';
import { INPUT_CONTROL_TYPE_ENUM } from '../../../config/constants';

const ProductLineItemAddonsDisplay = ({
  addOns,
  showVariantOptionsOnSingleLine,
  singleLineError,
  count
}) => {
  const { singleLineOptions, seperateLineOptions } = (addOns || []).reduce(
    (acc, addOn) => {
      if (addOn.isVariantOption && showVariantOptionsOnSingleLine) {
        acc.singleLineOptions.push(addOn);
      }
      else {
        acc.seperateLineOptions.push(addOn);
      }
      return acc;
    },
    { singleLineOptions: [], seperateLineOptions: [] }
  );

  return (
    addOns &&
    addOns.length > 0 && (
      <AppStack style={{ gap: 0 }}>
        {singleLineOptions.length > 0 && (
          <AppFlexbox style={{ gap: 8, alignItems: 'center' }}>
            <AppText style={{ fontSize: 14, color: '#666' }}>
              {singleLineOptions.map((addOn) => addOn.value).join(' / ')}
              {count !== undefined && ` (x${count})`}
            </AppText>

            {singleLineError && (
              <AppFlexbox
                style={{
                  alignItems: 'center',
                  gap: 5
                }}
              >
                <AlertCircle color="#C40000" size={15} />
                <AppText
                  style={{
                    fontSize: 12,
                    color: '#C40000'
                  }}
                >
                  {singleLineError}
                </AppText>
              </AppFlexbox>
            )}
          </AppFlexbox>
        )}

        {seperateLineOptions
          .sort((a, b) => a.sort - b.sort)
          .map((addOn) => {
            const label = addOn.name || addOn.productName || 'Addon';
            const isUrlValue = isUrlString(addOn.value);

            return (
              <AppFlexbox
                key={label + addOn.value}
                style={{
                  gap: 5,
                  paddingLeft:
                    showVariantOptionsOnSingleLine &&
                    singleLineOptions.length > 0
                      ? 12
                      : 0
                }}
              >
                <AppFlexbox style={{ gap: 5, alignItems: 'center' }}>
                  <AppText style={{ fontSize: 14, color: '#666' }}>
                    {label.charAt(0).toUpperCase() + label.slice(1)}:
                  </AppText>
                  {isUrlValue ||
                  addOn.fkRegFormControlType ===
                    INPUT_CONTROL_TYPE_ENUM.FILE_UPLOAD ? (
                    <AppFlexbox
                      style={{
                        gap: 10,
                        marginLeft: 5,
                        alignItems: 'center '
                      }}
                    >
                      <AppStack
                        style={{
                          width: 25,
                          height: 25,
                          justifyContent: 'center'
                        }}
                      >
                        <Image
                          fit="contain"
                          h="100%"
                          src={addOn.value}
                          w="100%"
                        />
                      </AppStack>
                      {isUrlValue && (
                        <Anchor
                          component="p"
                          onClick={(e) => {
                            e.preventDefault();
                            e.stopPropagation();
                            window.open(addOn.value, '_blank');
                          }}
                          style={{
                            fontSize: 14,
                            color: 'dodgerblue'
                          }}
                        >
                          Download image
                        </Anchor>
                      )}
                    </AppFlexbox>
                  ) : (
                    <AppText style={{ fontSize: 14, color: '#666' }}>
                      {addOn.value}
                    </AppText>
                  )}
                  {addOn.unitAmountInCents != null &&
                    addOn.unitAmountInCents > 0 && (
                      <AppFlexbox
                        style={{
                          gap: 5,
                          textAlign: 'end',
                          marginLeft: 10
                        }}
                      >
                        <AppText
                          style={{
                            fontSize: 14,
                            color: '#666',
                            fontWeight: 500
                          }}
                        >
                          <NumberFormatter
                            decimalScale={2}
                            displayType="text"
                            fixedDecimalScale
                            prefix="+$"
                            thousandSeparator
                            value={addOn.unitAmountInCents / 100}
                          />
                        </AppText>
                      </AppFlexbox>
                    )}
                </AppFlexbox>
              </AppFlexbox>
            );
          })}
      </AppStack>
    )
  );
};

ProductLineItemAddonsDisplay.propTypes = {
  addOns: PropTypes.array,
  count: PropTypes.number,
  showVariantOptionsOnSingleLine: PropTypes.bool,
  singleLineError: PropTypes.string
};

export default ProductLineItemAddonsDisplay;
